import React, { createContext, useContext, useEffect, useState } from "react";
import { IUser, useUsers } from "~/entity/Users";

interface IUserContext {
  dealerChoice: string | null;
  user: IUser | null;
}

const UserContext = createContext<IUserContext>({
  dealerChoice: null,
  user: null,
});

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { getMyUser } = useUsers();
  const [dealerChoice, setDealerChoice] = useState<string | null>(null);
  const [user, setUser] = useState<IUser | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await getMyUser();
        const userData = res.data?.user;
        if (userData) {
          setUser(userData);
          setDealerChoice(userData.dealerChoice);
          sessionStorage.setItem("dealerChoice", userData.dealerChoice);
        }
      } catch (e) {
        console.error("Ошибка при получении пользователя", e);
      }
    };

    fetchUser();
  }, []);

  return (
    <UserContext.Provider value={{ dealerChoice, user }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
